import ItemEventTypeService from "../ItemEventType/ItemEventType.service";
import ItemEventReplyDomainService from "../ItemEventReply/ItemEventReply.service";
import ActivityItemTypeService from "../ActivityItemType/ActivityItemType.service";
import ItemEventChangeValueTypeDomainService from "../ItemEventChangeValueType/ItemEventChangeValueType.service";
import ItemStatusDomainService from "../ItemStatus/ItemStatus.service";
export default class ItemUpdateService {
    static createComment(comment, person, student, activityItemTypeId, itemId, optionalArgs = {}) {
        return {
            activityItemTypeId,
            currentItemTitle: optionalArgs.currentItemTitle || "",
            // @ts-expect-error - TS2322 - Type '{ activityItemTypeId: number; currentItemTitle: string; contextPerson: PersonLite; editable: boolean; deletable: boolean; id: number; itemIdInt: number | null; itemIdUUID: string | null; ... 5 more ...; itemEventType: { ...; }; }' is not assignable to type 'ItemUpdate'.
            contextPerson: student,
            editable: optionalArgs.editable != null ? optionalArgs.editable : true,
            deletable: optionalArgs.deletable != null ? optionalArgs.deletable : true,
            id: 0,
            itemIdInt: typeof itemId === "number" ? itemId : null,
            itemIdUUID: typeof itemId === "string" ? itemId : null,
            bodyIsHTML: false,
            title: "Comment",
            body: comment,
            eventDate: optionalArgs.date || new Date(),
            eventCreatedBy: person,
            itemEventType: {
                id: ItemEventTypeService.CommentId,
                name: "Comment",
                isTimeSeries: false,
            },
        };
    }
    static createAlertClosed(person, student, alertId, optionalArgs = {}) {
        return {
            title: "Alert Closed",
            body: optionalArgs.comment || "",
            // @ts-expect-error - TS2322 - Type '{ title: string; body: string; contextPerson: PersonLite; eventDate: Date; eventCreatedBy: PersonLite; itemEventType: { id: number; name: string; isTimeSeries: false; }; ... 8 more ...; changes: { ...; }[]; }' is not assignable to type 'ItemUpdate'.
            contextPerson: student,
            eventDate: optionalArgs.date || new Date(),
            eventCreatedBy: person,
            itemEventType: {
                id: ItemEventTypeService.ChangeStatusId,
                name: "AlertClosed",
                isTimeSeries: false,
            },
            activityItemTypeId: ActivityItemTypeService.PersonAlertId,
            currentItemTitle: optionalArgs.currentItemTitle || "",
            editable: optionalArgs.editable != null ? optionalArgs.editable : false,
            deletable: false,
            id: 0,
            itemIdInt: alertId,
            itemIdUUID: null,
            bodyIsHTML: false,
            changes: [
                {
                    attributeName: "status",
                    displayName: "Status",
                    newValue: {
                        isList: false,
                        changeValues: [
                            {
                                displayName: "Closed",
                                itemEventChangeValueTypeId: ItemEventChangeValueTypeDomainService.ITEM_STATUS_ID,
                                idLong: ItemStatusDomainService.PERSON_ALERT_CLOSED_ID,
                                idUUID: null,
                                description: null,
                            },
                        ],
                    },
                    oldValue: {
                        isList: false,
                        changeValues: [
                            {
                                displayName: "Open",
                                itemEventChangeValueTypeId: ItemEventChangeValueTypeDomainService.ITEM_STATUS_ID,
                                idLong: ItemStatusDomainService.PERSON_ALERT_OPEN_ID,
                                idUUID: null,
                                description: null,
                            },
                        ],
                    },
                },
            ],
        };
    }
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ replies: any; eventDate: Date; editedDate: any; latestReplyDate: any; }' is missing the following properties from type 'ItemUpdate': id, itemIdInt, itemIdUUID, activityItemTypeId, and 9 more.
        return Object.assign(Object.assign({}, json), { replies: json.replies && json.replies.map(ItemEventReplyDomainService.fromJSON), eventDate: new Date(json.eventDate), editedDate: json.editedDate && new Date(json.editedDate), latestReplyDate: json.latestReplyDate && new Date(json.latestReplyDate) });
    }
}
